module.exports = __webpack_public_path__ + "img/GUI_localizatino_v1.016a1c57.png";